import { useState, useCallback } from "react";
import { CpuRamAnalysisService } from "../../../application/services/aiServices/cpuRamAnalysisService";

const cpuRamAnalysisService = new CpuRamAnalysisService();

export const useCpuRamAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cpuRamAnalysis, setCpuRamAnalysis] = useState(null);

  const getCpuRamAnalysis = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await cpuRamAnalysisService.getCpuRamAnalysis(vmId);
      if (result.success) {
        setCpuRamAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeAllVmsCpuRam = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await cpuRamAnalysisService.analyzeAllVmsCpuRam();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getCpuRamAnalysis,
    analyzeAllVmsCpuRam,
    cpuRamAnalysis,
    loading,
    error,
  };
};